import { LoadingStudentAggStats, LoadingGroupAggStats, LoadingStudentStats } from '@/loadingUtils'
import { statsModule } from '@/store/stats/module'
import { studentModule } from '@/store/student/module'
import type { StudentAggStats, GroupAggStats, StudentStats } from '@/store/stats/types'
import { groupModule } from '@/store/group/module'
import { isPromise } from '@/utils'

const getStudentStats = (): Record<string, StudentStats> => {
    const studentStats = statsModule.state.studentStats
    return Object.keys(studentStats).reduce<Record<string, StudentStats>>((statsAcc, studentId) => {
        const currentStudentStats = studentStats[studentId]?.value
        if (currentStudentStats && !(isPromise(currentStudentStats))) {
            statsAcc[studentId] = currentStudentStats
        } else {
            statsAcc[studentId] = LoadingStudentStats
        }
        return statsAcc
    }, {})
}

const getStudentAggStats = () => {
    const aggStats = statsModule.state.studentAggStats
    return Object.keys(aggStats).reduce<Record<string, StudentAggStats>>((statsAcc, studentId) => {
        const currentStudentStats = aggStats[studentId]?.value
        if (currentStudentStats && !(currentStudentStats instanceof Promise)) {
            statsAcc[studentId] = currentStudentStats
        } else {
            statsAcc[studentId] = LoadingStudentAggStats
        }
        return statsAcc
    }, {})
}

const getCurrentStudentAggStats = () => {
    const studentId = studentModule.state.currentStudentId
    const studentAggStats = studentId && statsModule.getters.getStudentAggStats()[studentId]
    if (
        studentAggStats
        && !(studentAggStats instanceof Promise)
    ) {
        return studentAggStats
    } else {
        return LoadingStudentAggStats
    }
}

const getCurrentStudentStats = () => {
    const studentId = studentModule.state.currentStudentId
    const studentStats = studentId && statsModule.getters.getStudentStats()[studentId]
    if (
        studentStats
        && !(isPromise(studentStats))
    ) {
        return studentStats
    } else {
        return LoadingStudentStats
    }
}

const getCurrentGroupAggStats = (): GroupAggStats => {
    const groupId = groupModule.state.currentGroupId
    const groupStats = groupId && statsModule.state.groupAggStats[groupId]?.value
    if (
        groupStats
        && !(groupStats instanceof Promise)
    ) {
        return groupStats
    } else {
        return LoadingGroupAggStats
    }
}

export default {
    getCurrentStudentStats,
    getCurrentStudentAggStats,
    getStudentStats,
    getStudentAggStats,
    getCurrentGroupAggStats,
}
